import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_MachineOrder = _resolveComponent("MachineOrder")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_Uploader = _resolveComponent("Uploader")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_ResponsiveRow = _resolveComponent("ResponsiveRow")!
  const _component_page_card = _resolveComponent("page-card")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_app_page = _resolveComponent("app-page")!

  return (_openBlock(), _createBlock(_component_app_page, null, {
    main: _withCtx(() => [
      _createVNode(_component_el_form, {
        model: _ctx.formData,
        ref: "mainFormRef",
        "label-width": "90px",
        rules: _ctx.rules
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "所属区域",
            prop: "regionId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.regionId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.regionId) = $event)),
                placeholder: "请选择所属区域"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.REGION_LIST, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "需求类型",
            prop: "demandTaskType"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio_group, {
                modelValue: _ctx.formData.demandTaskType,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.demandTaskType) = $event)),
                disabled: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.DEMAND_TASK_MACHINE_LIST, (item) => {
                    return (_openBlock(), _createBlock(_component_el_radio_button, {
                      key: item.value,
                      label: item.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_MachineOrder, {
            ref: "machineRef",
            categoryTree: _ctx.categoryTree,
            clothesSize: _ctx.clothesSize,
            qualityLevel: _ctx.qualityLevel,
            modelValue: _ctx.machineFormData,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.machineFormData) = $event))
          }, null, 8, ["categoryTree", "clothesSize", "qualityLevel", "modelValue"]),
          _createVNode(_component_page_card, { title: "审批信息" }, {
            default: _withCtx(() => [
              _createVNode(_component_ResponsiveRow, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "飞书审批编号",
                    prop: "serialNumber",
                    "label-width": "110px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.serialNumber,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.serialNumber) = $event)),
                        placeholder: "请输入飞书审批编号",
                        maxlength: 20
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 16 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "审批截图",
                        prop: "_images"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Uploader, {
                            modelValue: _ctx.formData._images,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData._images) = $event)),
                            size: "mini",
                            limit: 3,
                            sizeLimit: 20,
                            accept: ".png, .jpg, .jpeg",
                            checkAccept: true,
                            tips: "最多可以上传 3 张图片, 支持png、jpg、jpeg图片格式"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    ffooter: _withCtx(() => [
      _createVNode(_component_el_row, {
        style: {"width":"100%"},
        type: "flex",
        justify: "center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            plain: "",
            onClick: _ctx.handleCancel
          }, {
            default: _withCtx(() => [
              _createTextVNode("取 消")
            ]),
            _: 1
          }, 8, ["onClick"]),
          (_ctx.$has(_ctx.permissionConfig.SUBMIT))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                disabled: !_ctx.isCreditCustomer,
                type: "primary",
                onClick: _ctx.handleSubmit
              }, {
                default: _withCtx(() => [
                  _createTextVNode("提 交")
                ]),
                _: 1
              }, 8, ["disabled", "onClick"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}